module.exports = __webpack_public_path__ + "img/loading-3.7647bb75.gif";